//React Components 
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
//Images
import PCCcoin from "./img/PCCcoin.png"
import PCCcoin1 from "./img/PCCcoin1.png"
import PCCcoin10 from "./img/PCCcoin10.png"
import dollarOne from "./img/dollas-one.jpeg"
import dollarFive from "./img/dollas-five.jpeg"
import dollarTen from "./img/dollas-ten.jpeg"
import dollarTwenty from "./img/dollas-twenty.jpeg"
import dollarFifty from "./img/dollas-fifty.jpeg"
import dollarOneHundred from "./img/dollas-one-hundred.png"
import coin1 from "./img/coin1.png"
import coin5 from "./img/coin5.png"
import coin10 from "./img/coin10.png"
import coin25 from "./img/coin25.png"
import coin1b from "./img/coin1b.png"
import Modal from 'react-bootstrap/Modal';
import { RenderIf } from '../utils/RenderIf';
import ErrorAlert from '../Alerts/ErrorAlert';
import { RequestLocalFetchAPI } from '../../api/Paymentpost/RequestLocal';

//Sweet alert
import Swal from "sweetalert2";

//api
import { MachinesFetchAPI } from '../../api/Machines';
import LoadingAlert from '../Alerts/LoadingAlert';



const Cashierpost = ({ setChange, setAmountOrder, setOrderNumber, setModalShow, order_data, statusCash, paymentInfo, mixto, setAmountPayment, amountPending, amountPayment, total }) => {
    let { business_code, branchoffice_code } = useParams();
    const [counter, setCounter] = useState(0)
    const [loader, setLoader] = useState(0)
    const [botonDeshabilitado, setBotonDeshabilitado] = useState(false);
    const user = JSON.parse(localStorage.getItem('user'))

    setAmountOrder(order_data.total.toFixed(2))
    //setOrderNumber(order_data.code)

    const checkAmount = () => {
        let total = (counter.toFixed(2) - (order_data.total.toFixed(2))).toFixed(2);
        if (total >= 0) {
            setLoader(1)
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Debe ingresar el monto a pagar o superior.',
                showConfirmButton: false,
                timer: 1500
            })
        }
    }

    const actionCounter = (value) => {
        let newAmount = (counter + value);
        if (mixto == true) {

            if (newAmount > amountPending) {
                setAmountPayment(amountPending)
                setAmountOrder(amountPending)
                ErrorAlert("", "El valor ingresado supera el valor pendiente", "warning")
            } else {
                setAmountPayment(newAmount)
                setAmountOrder(newAmount)
            }

        }
        setCounter((counter) => counter + value)
    }

    //Function to populate the card dollar
    const CardDollar = (props) => {
        return (
            <button type="button" className="cash-bill" onClick={() => actionCounter(props.value)}>
                <img src={props.imgDollar} alt="" className="cash-bill-img" loading="lazy" />
                <span className="cash-bill-value" translate="no">${props.value}</span>
            </button>
        )
    }

    //Function to populate the card coin 
    const CardCoin = (props) => {
        return (
            <button type="button" className="cash-coin" onClick={() => actionCounter(props.value)}>
                <img src={props.imgDollar} alt="" className="cash-coin-img" loading="lazy" />
                <span className="cash-coin-value" translate="no">${props.value}</span>
            </button>
        )
    }

    //save change cash
    const setChangeOrder = () => {
        let valorCambio = (counter.toFixed(2) - (order_data.total.toFixed(2))).toFixed(2)
        if (valorCambio >= 0) {

            setChange(valorCambio);
        }
    }

    //Consultar data inicial 
    const putOrderMachine = async (status, order) => {
        let boton = ""
        let text = ""
        let title = ""
        let respuestaAlert = ""
        let valorCambio = (counter.toFixed(2) - (order_data.total.toFixed(2))).toFixed(2)
        setBotonDeshabilitado(true);
        if (valorCambio >= 0 || status == 8) {
            if (status == 7) {
                title = "Aprobar Orden: " + order
                text = "Monto de la transaccion: " + order_data.total.toFixed(2) + ", Cambio: " + valorCambio
                boton = "Si, Aprobar pago"
                respuestaAlert = "Pago exitoso"
                setChange(valorCambio);
            }


            //Boton cancelar pago 
            else if (status == 8) {
                title = "Esta seguro que quiere cancelar la orden"
                text = "Orden: " + order
                boton = "Si, cancelar pago"
                respuestaAlert = "Pago cancelado con exito"
                setBotonDeshabilitado(true);
            }


            //Boton cancelar pago 
            Swal.fire({
                title: title,
                text: text,
                icon: 'warning',
                // showCancelButton: true,
                showDenyButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                // cancelButtonText: 'No ggggg',
                denyButtonText: ` No `,
                confirmButtonText: boton

            }).then((result) => {
                if (result.isConfirmed) {
                    peticion()
                    setBotonDeshabilitado(false);
                }
                else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    setBotonDeshabilitado(false);

                }

            })

        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Debe ingresar el monto a pagar o superior.',
                showConfirmButton: false,
                timer: 1500
            })

        }

        const peticion = async () => {
            let data = {
                "order_code": order,
                "business_code": business_code,
                "branchoffice_code": branchoffice_code,
                "status": status,
                "user_id": user && user.id !== undefined ? user.id : undefined
            }

            try {
                const response = await MachinesFetchAPI.updateStateOrder(data)
                console.log(response);

            } catch (err) {

                if (err.request.response == "{\"error\":\"Orden aun no ha sido eliminada, estado aun no es realizado o cancelado\",\"success\":true}") {
                    console.log("Exitoso");

                    setModalShow(false);
                    LoadingAlert({ title: "Cancelando orden", text: "Espere por favor...", icon: "loading" })
                    /* Swal.fire({
                        icon: 'success',
                        title: respuestaAlert,
                        showConfirmButton: false,
                        timer: 1500
                    }) */
                }
                console.log(err)
            }
        }
    }

    /* ============================================================
       PASO 1 — contar el efectivo (cuerpo)
    ============================================================ */
    const renderCahs = () => {
        return (
            <>
                <div className="cash-display">
                    <div className="cash-display-text">
                        <span className="cash-display-label">Monto recibido</span>
                        <span className="cash-display-amount" translate="no">${counter.toFixed(2)}</span>
                    </div>
                    <button
                        type="button"
                        className="cash-exact"
                        onClick={() => setCounter(order_data.total)}
                    >
                        Monto igual
                    </button>
                </div>

                <div className="cash-picker">

                    <section className="cash-group">
                        <h3 className="cash-group-title">Billetes</h3>
                        <div className="cash-bills">
                            {paymentInfo.payment == "Efectivo" ? <>
                                <CardDollar value={1} imgDollar={dollarOne} />
                                <CardDollar value={5} imgDollar={dollarFive} />
                                <CardDollar value={10} imgDollar={dollarTen} />
                                <CardDollar value={20} imgDollar={dollarTwenty} />
                                <CardDollar value={50} imgDollar={dollarFifty} />
                                <CardDollar value={100} imgDollar={dollarOneHundred} />
                            </> : <>
                                <CardDollar value={1} imgDollar={PCCcoin1} />
                                <CardDollar value={5} imgDollar={PCCcoin} />
                                <CardDollar value={10} imgDollar={PCCcoin10} />
                            </>}
                        </div>
                    </section>

                    {paymentInfo.payment == "Efectivo" ? <>
                        <section className="cash-group">
                            <h3 className="cash-group-title">Monedas</h3>
                            <div className="cash-coins">
                                <CardCoin value={0.01} imgDollar={coin1} />
                                <CardCoin value={0.05} imgDollar={coin5} />
                                <CardCoin value={0.10} imgDollar={coin10} />
                                <CardCoin value={0.25} imgDollar={coin25} />
                                <CardCoin value={1.00} imgDollar={coin1b} />
                            </div>
                        </section>
                    </> : <>
                        <section className="cash-group">
                            <h3 className="cash-group-title">Monedas</h3>
                            <div className="cash-coins">
                                <CardCoin value={0.25} imgDollar={coin25} />
                            </div>
                        </section>
                    </>}

                </div>
            </>
        )
    }

    /* ============================================================
       PASO 2 — confirmar la transacción (cuerpo)
    ============================================================ */
    const nextModal = () => {
        return (
            <>
                <h3 className="cash-group-title">Detalles de transacción</h3>

                <div className="cash-summary">

                    <div className="cash-stat cash-stat--in">
                        <span className="cash-stat-label">Monto recibido</span>
                        <span className="cash-stat-val" translate="no">${counter.toFixed(2)}</span>
                    </div>

                    <div className="cash-stat cash-stat--out">
                        <span className="cash-stat-label">
                            {mixto == true ? <>Saldo pendiente</> : <>Monto a devolver</>}
                        </span>
                        <span className="cash-stat-val" translate="no">
                            ${mixto == true ? <>{(amountPending - counter).toFixed(2)}</> : <> {(counter.toFixed(2) - (order_data.total.toFixed(2))).toFixed(2)}</>}
                        </span>
                    </div>

                    {mixto !== true ? <>
                        <div className="cash-stat cash-stat--due">
                            <span className="cash-stat-label">Monto a pagar</span>
                            <span className="cash-stat-val" translate="no">${order_data.total.toFixed(2)}</span>
                        </div>
                    </> : <></>}

                </div>
            </>
        )
    }


    return (
        <>
            {/* ---------------- BODY ---------------- */}
            <div className="cash-body">
                <div className="cash-step">
                    <RenderIf isTrue={loader == 0}>Paso 1 de 2 · Cuente el efectivo recibido</RenderIf>
                    <RenderIf isTrue={loader == 1}>Paso 2 de 2 · Confirme la transacción</RenderIf>
                </div>

                <RenderIf isTrue={loader == 0}>
                    {renderCahs()}
                </RenderIf>
                <RenderIf isTrue={loader == 1}>
                    {nextModal()}
                </RenderIf>
            </div>

            {/* ---------------- FOOTER ---------------- */}
            <div className="cash-foot">
                <RenderIf isTrue={loader == 0}>
                    <div className="cash-foot-total">
                        <span className="cash-foot-label">Monto recibido</span>
                        <span className="cash-foot-amount" translate="no">${counter.toFixed(2)}</span>
                    </div>

                    <div className="cash-foot-actions">
                        <button
                            className="cash-btn cash-btn--ghost"
                            onClick={() => setCounter(0)}
                        >
                            Borrar
                        </button>
                        <button
                            className="cash-btn cash-btn--danger"
                            onClick={() => statusCash(2)}
                        >
                            Cancelar pago
                        </button>
                        <button
                            className="cash-btn cash-btn--go"
                            onClick={() => checkAmount() /*putOrderMachine(7, order_data.code)*/}
                        >
                            Continuar pago
                        </button>
                    </div>
                </RenderIf>

                <RenderIf isTrue={loader == 1}>
                    <div className="cash-foot-total">
                        <span className="cash-foot-label">
                            {mixto == true ? "Saldo pendiente" : "Monto a devolver"}
                        </span>
                        <span className="cash-foot-amount" translate="no">
                            ${mixto == true ? (amountPending - counter).toFixed(2) : (counter.toFixed(2) - (order_data.total.toFixed(2))).toFixed(2)}
                        </span>
                    </div>

                    <div className="cash-foot-actions">
                        <button
                            className="cash-btn cash-btn--danger"
                            onClick={() => statusCash(2)}
                        >
                            Cancelar pago
                        </button>
                        <button
                            className="cash-btn cash-btn--go"
                            disabled={botonDeshabilitado}
                            onClick={() => (statusCash(1), setChangeOrder())}
                        >
                            Finalizar pago
                        </button>
                    </div>
                </RenderIf>
            </div>
        </>
    )
}

export default Cashierpost